'use client'
import { Skeleton } from '@morpho-org/ui-v6/server'

import {
  Table,
  TableScrollArea,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from '@/components/common/Table/CompactTable/Table'

import { MARKET_ALLOCATION_SKELETON_ROWS } from '../config/config'

const MarketAllocationLoading = () => {
  return (
    // No pagination: tables of up to PAGE_SIZE markets don't render it.
    <TableScrollArea aria-hidden className="grid w-full">
      <Table tableVariant="compact">
        <Thead>
          <tr>
            <Th tableVariant="compact">
              <Skeleton className="h-md w-[80px]" />
            </Th>
          </tr>
        </Thead>
        <Tbody tableVariant="compact">
          {Array.from({ length: MARKET_ALLOCATION_SKELETON_ROWS }, (_, index) => (
            <Tr key={index}>
              <Td>
                <Skeleton className="h-md w-[160px]" />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableScrollArea>
  )
}

export default MarketAllocationLoading
